module.exports = __webpack_public_path__ + "img/010.f8e4a2ba.png";